export const defaultValues = {
  eventFee: '',
  flight: '',
  handicap: '',
  user: {
    email: '',
    firstName: '',
    lastName: '',
    profile: {
      ghinNumber: ''
    }
  }
};
